import { status } from "../_constants/commonLhd";
import { sellCarConstant } from "../_constants/sellCar.constant";

let Initialstate = {}

export function sell(state = Initialstate, action) {
    switch (action.type) {
        case sellCarConstant.GET_SELLCAR_REQUEST:
            return {
                ...state,
                sellCar_status: status.IN_PROGRESS,
                sellCar_data: null
            };
        case sellCarConstant.GET_SELLCAR_SUCCESS:
            return {
                ...state,
                sellCar_status: status.SUCCESS,
                sellCar_data: action.data
            };
        case sellCarConstant.GET_SELLCAR_FAILURE:
            return {
                ...state,
                sellCar_status: status.FAILURE,
                sellCar_data: action.data
            };
        default:
            return state;
    }
}